import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<p class="text-center mt-3 mb-3 bold">1 AKTO</p>

		<p class="mb-1">
			Elira ario de la <span class="bold">Duko</span>.
		</p>

		<p class="mb-4">
			Kiam malfermiĝas kurteno, li staras sur la scenejo en tradicia pozo kaj kantas 
		</p>
		
		<div class="mb-3 kanto duk-kanto">
			<p class="kanto-legend">
				Kanto (laŭ la melodio de ario de Judaso «I see the bloody distraction and elimination because of one man» el la rock-opero "Jesus Christ Superstar" de Andrew Lloyd Webber)
			</p>
			<div class="no-inner-indent flex-center">
				<p>
					- Mi vidas belan prosperon de l’ lingv’ Esperanto en urbo Odes’.<br/>
					Mi havas fortan esperon, ke plenumiĝos belega promes’,<br/>
					Promes’, promes’, en urbo Odes’,<br/>
					Ke kreskos movado en urbo Odes’!
				</p>
			</div>

		</div>
		
		<p class="mb-1">
			Alkuras knabino, poste knabo.
		</p>
		
		<p class="mb-1">
			<span class="bold">Knabino</span>: Ho, kie trovi ĝin? Neniu en Odessa scias, kie troviĝas Verdaĵo! Ho, knabo, eble vi scias? Kie estas “Verdaĵo” en Odessa? 
		</p>
		
		<p class="mb-1">
			<span class="bold">Knabo</span>: Verdaĵo estas ĉie en Odessa! 
			En nia urbo tre multas arboj, (h)erboj, kaj orboj – aĥ, arbustoj… kaj bustoj… 
			Ekzemple, la busto de Zamenhof; kaj multaj aliaj belaj bustoj (rigardas ŝian buston).
		</p>
		
		<p class="mb-1">
			<span class="bold">Knabino</span>: Ho, vi nenion komprenas! 
			Mi serĉas Esperanto-klubon «Verdaĵo». 
			Mi aŭdis, ke ili organizas junularan ekspedicion al naturo, kaj mi volas aliĝi. 
			Mi tiel ŝatas verdan naturon… veran naturon… viran naturon… veran viran naturon…
		</p>
		
		<p class="mb-1">
			<span class="bold">Knabo</span>: Nu, tiam vi trafis ĝuste. 
			Mi estas el tiu klubo; kaj morgaŭ startos la ekspedicio. 
			Interalie, kia estas via nomo?
		</p>
		
		<p class="mb-1">
			<span class="bold">Knabino</span>: Mi estas Ina.
		</p>
		
		<p class="mb-1">
			<span class="bold">Knabo</span>: Kaj mi estas Anton.
		</p>
		
		<p class="mb-3">
			<span class="bold">Knabino</span>: Aĥ, mi tiel amas Esper-Anton!
		</p>
		
		<p class="mb-3">
			Kantas kune:
		</p>
		
		<div class="mb-4 kanto">
			<p class="kanto-legend">
				Kanto (laŭ la melodio «La kri’», esperanta popolkanto, angla popolkanto «My bonnie»)
			</p>
			<table>
				<tr>
					<td style="vertical-align: top;"> 
						<span class="bold">Rf.</span>:
					</td>
					<td>
						<i>Al naturo – estas deziro de ni, de ni!</i><br/>
						<i>Al la Dnestro – estas deziro de ni!</i>
					</td>
				</tr>
			</table>
			<div class="no-inner-indent flex-center">
				<p>
					Ni ŝatas la verdan naturon,<br/>
					Nin ravas kantad’ de birdar’,<br/>
					Transiras ni la urbomuron,<br/>
					Sed kuras ni ne al la mar’!
				</p>
			</div>
			<span class="bold">Rf.</span>
		</div>


		<p class="text-center mt-3 mb-5 bold">2 AKTO</p>

		<div class="mb-3 kanto">
			<p class="kanto-legend">
				Ĥoro de «Verdaĵo» (laŭ la melodio de «Ĥoro de apostoloj» el «Jesus Christ Superstar»)
			</p>
			<div class="no-inner-indent flex-center kanto-de-apostoloj">
				<p>
					Ni en tendoj loĝas sur la bordo,<br/>
					Kaj vekiĝas ni kun la aŭror’.<br/>
					Komendant’ severe vokas nin al ordo,<br/>
					Kaj pro ni disflugas birda ĥor’…
				</p>
			</div>
		</div>
																								
		
		<p class="mb-1">
			Aperas la Komendanto.
		</p>
		
		<p class="mb-1">
			<span class="bold">Komendanto</span>: Hej, 
			2 personoj por la akvo: remu al alia bordo kaj prenu el fonto; 
			2 personoj por lignaĵo: grimpu al arboj kaj prenu po plenbrakoj; 
			2 personoj por aero: prenu po fosilo kaj elfosu fin-fine novan necesejan kavon!
		</p>

		<p class="mb-3">
			Deĵorantoj – al kuirejo; ĉiuj aliuj – al scienca ekskurso! 
		</p>

		<p class="mb-3">
			Aperas la <span class="bold">Ekskursgvidanto</span>, kantas, saltante kaj gestikulante:
		</p>

		<div class="mb-3 kanto">
			<p class="kanto-legend">
				Kanto (laŭ la melodio de «Eskadron'» de О. Gazmanov)
			</p>
			<div class="no-inner-indent flex-center">
				<p class="mb-2">
					La ekskurso al kana ĝangal’,<br/>
					Sekvu min, ho junuloj, sen tim’!<br/>
					Ni trahakos la vojon en kana ĝangal’,<br/>
					Unusola nur restos viktim’ !<br/>
					Sola dronos en marĉo viktim’!
				</p>
				
				<p class="mb-2">
					La ekskurso por birda observ’!<br/>
					Sekvu min, ho junuloj, sen tim’!<br/>
					Ni surgrimpos la arbojn por birda observ’,<br/>
					Unusola nur restos viktim’ !<br/>
					Falos teren nur sola viktim’!
				</p>
				
				<p class="mb-2">
					La ekskurso al stepa herbej’!<br/>
					Sekvu min, ho junuloj, sen tim’!<br/>
					Ni kolektos la herbojn en stepa are’<br/>
					Unusola nur restos viktim’ !<br/>
					Pro varmeg’ svenos sola viktim’!
				</p>
				
				<p class="mb-2">
					La ekskurso al delta marĉej’!<br/>
					Sekvu min, ho junuloj, sen tim’!<br/>
					Ni esploros hirudojn en delta marĉej’,<br/>
					Unusola nur restos viktim’ !<br/>
					Mortmordita hirude viktim’!
				</p>
				
				<p class="mb-2">
					La ekskurso al kana ĝangal’!<br/>
					La ekskurso por birda observ’!<br/>
					La ekskurso al stepa herbej’!<br/>
					La ekskurso al delta marĉej’!<br/>
					Sekvu min, ho junuloj, sen tim’!
				</p>
			</div>
		</div>
		
		<p class="mb-4">
			Svingante papili-kaptujon, foriras sola.
		</p>
		
		<p class="text-center mt-3 mb-1 bold">3 AKTO</p>
		
		<p class="mb-3">
			Vespere.
		</p>
		
		<p class="mb-1">
			<span class="bold">Ĉiuj kune aŭ alterne</span>:
		</p>
		
		<p class="mb-1">
			-Tiu legomo estas frandaĵo de gnomoj…
		</p>
		
		<p class="mb-1">
			-Sur la flago de Nederlando oranĝa strio simbolas protestantojn, verda – katolikojn; sed kion simbolas la blanka strio? – Unu minuton por respondo!
		</p>
		
		<p class="mb-1">
			-En Parizo oni produktas parfumojn por hundoj – ĉu vi kredas aŭ ne?
		</p>
		
		<p class="mb-1">
			-Io ronda… Ĉu kapo? Ne, abstrakta nocio… Nu, montru plu!
		</p>
		
		<p class="mb-1">
			-Ĉu vivanta? Ĉu farita de homo?
		</p>
		
		<p class="mb-3">
			-Estas kontakto!
		</p>
		
		<p class="mb-1">
			<span class="bold">Ina</span>: Ne, vane mi venis ĉi-tien! Eĉ kontaktoj ĉe ili estas intelektaj.
		</p>
		
		<p class="mb-3">
			<span class="bold">Godzila</span>: Ĉu vi volas alian kontakton? Nu, ni iru! (Kaptas ŝin, levas, forportas).
		</p>
		
		<p class="mb-4 text-center">
			(Plena mallumo)
		</p>
		
		<p class="text-center mt-3 mb-3 bold">4 AKTO</p>
		
		<p class="mb-3">
			Matena kunveno.
		</p>
		
		<p class="mb-1">
			<span class="bold">Ekspedici-gvidanto</span>: Do, hieraŭ ni konstruis 0,2 da nesto por agloj; rompis 41 branĉon de la observa arbo kaj dum 4 horoj kalkulis 0,4 birdojn. 
			Kaptis 47 hirudojn; el ili 43 kaptis Anton per siaj propraj femuroj. 
			Aliro al nia ĉampiono nur po unu, kaj kun retenita spiro. 
			Li kuŝas en la tendo 03. 
		</p>
		
		<p class="mb-3">
			Al hieraŭaj deĵorantoj mi proklamas riproĉon: ja ne eblas fari vespermanĝon nur el kondensita lakto!
		</p>
		
		<p class="mb-3">
			<span class="bold">Ĉiuj kune</span>: E-e-e-e-eblas!
		</p>
		
		<p class="mb-3">
			<span class="bold">Ekspedici-gvidanto</span>: Kaj la ekskursoj hodiaŭ…
		</p>
		
		<p class="mb-4 text-center">
			(Plena mallumo)
		</p>
		
		
		<p class="text-center mt-3 mb-1 bold">5 AKTO</p>
		
		<p class="mb-1">
			<span class="bold">Ina</span>: Adiaŭ, amikoj! 
			Estis neforgeseblaj tagoj! 
			Ĉu ni forgesos tiujn belajn trilojn de kuloj nokte, tiujn deĵoradojn apud lignofajro, tiujn pizajn supojn kaj intelektajn ludojn?! 
			Ne, mi neniam estis en tia ekspedicio!
		</p>
		
		<p class="mb-4">
			Kantas:
		</p>
		
		<div class="mb-3 kanto">
			<p class="kanto-legend">
				Kanto laŭ la melodio «Ĝis revido, kara, ne forgesu min» de M. Legrand el la filmo «Les Parapluies de Cherbourg»)
			</p>
			<div class="no-inner-indent flex-center">
				<p class="mb-2">
					Ĝis revido, Dnestro, ne forgesu min!<br/>
					Ĝis revid’, Odeso, ne forgesu min!<br/>
					Ĝis revid’, „Verdaĵo“, ne forgesu min -<br/> 
					Mi revenos por sekva tendar’!
				</p>
				<p class="mb-2">
					<i><span class="bold">(Ĉiuj kune:)</span></i><br/>
					Ĝis revido, Dnestro, ne forgesu nin!<br/>
					Ni eltenis ĉion-ĉion kun obstin’,<br/>
					Ni feliĉis sur viaj bordoj,<br/>
					Dankon, Dnestro, ho dankon al vi!
				</p>
			</div>
		</div>
		
		<p class="text-center mt-3 mb-1 bold">FINO</p>
		`
	)
}

const itemName = {
	esp: 'Rok-opero'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp
	}
}

export default item;